import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityTimelineEntry = ({ activity }) => {
  const getSeverityColor = (severity) => {
    if (severity === 'mild') return 'text-success bg-success/10';
    if (severity === 'moderate') return 'text-warning bg-warning/10';
    return 'text-error bg-error/10';
  };

  const getSeverityIcon = (severity) => {
    if (severity === 'mild') return 'SmilePlus';
    if (severity === 'moderate') return 'Meh';
    return 'Frown';
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const formatTime = (date) => {
    const d = new Date(date);
    return d?.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  };

  const getCategoryIcon = (category) => {
    const icons = {
      head_neck: 'Brain',
      respiratory: 'Wind',
      digestive: 'Apple',
      musculoskeletal: 'Bone',
      skin: 'Sparkles',
      cardiovascular: '/assets/images/MyBodyToday_logo_design2-removebg-preview1-1770673381636.png',
      neurological: 'Zap',
      other: 'AlertCircle'
    };
    return icons?.[category] || 'AlertCircle';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 transition-smooth hover:shadow-therapeutic">
      <div className="flex items-start gap-3">
        <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center ${getSeverityColor(activity?.severity)}`}>
          <Icon name={getSeverityIcon(activity?.severity)} size={18} strokeWidth={2} />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div>
              <h4 className="text-sm font-semibold text-foreground line-clamp-1">
                {activity?.managedProfileName}
              </h4>
              <p className="text-xs text-muted-foreground capitalize">
                {activity?.relationship?.replace('_', ' ')}
              </p>
            </div>
            <div className="text-right">
              <p className="text-xs text-muted-foreground">
                {formatDate(activity?.createdAt)}
              </p>
              <p className="text-xs text-muted-foreground">
                {formatTime(activity?.createdAt)}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 mb-2">
            <Icon name={getCategoryIcon(activity?.category)} size={14} strokeWidth={2} className="text-muted-foreground" />
            <span className="text-sm text-foreground capitalize">
              {activity?.category?.replace('_', ' ')}
            </span>
          </div>

          {activity?.symptoms && activity?.symptoms?.length > 0 && (
            <div className="flex flex-wrap gap-1 mb-2">
              {activity?.symptoms?.slice(0, 3)?.map((symptom, index) => (
                <span 
                  key={index}
                  className="px-2 py-1 rounded-md bg-accent/10 text-accent text-xs font-medium"
                >
                  {symptom}
                </span>
              ))}
              {activity?.symptoms?.length > 3 && (
                <span className="px-2 py-1 rounded-md bg-muted text-muted-foreground text-xs font-medium">
                  +{activity?.symptoms?.length - 3} more
                </span>
              )}
            </div>
          )}

          {activity?.description && (
            <p className="text-sm text-muted-foreground line-clamp-2">
              {activity?.description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityTimelineEntry;